export const CONTACT_MODULE_NAME = "Liên hệ (đối tác)";
export const CONTACT_MODULE_URL = "/sales/contact";
export const CONTACT_API_PATH = "/v1/contact";
